import { Button } from '@mui/material';
import { Google } from '@mui/icons-material';
import baseURL from '../config'; // Ensure baseURL points to your backend API
import COLORS from '../../../../constants/colors';

const GoogleLoginButton = () => {
    const handleGoogleLogin = () => {
        window.location.href = `https://yambaafrica.com/api/auth/google`;
    };

    return (
        <Button
            onClick={handleGoogleLogin} // Redirects to backend for Google Auth
            variant="outlined"
            fullWidth
            startIcon={<Google />}
            sx={{
                borderColor: COLORS.primary,
                color: COLORS.primary,
                borderRadius: '10px',
                fontSize: '0.9rem',
                textTransform: 'none',
                py: 1.2,
                '&:hover': { backgroundColor: COLORS.primary, color: COLORS.white },
            }}
        >
            Sign up with Google
        </Button>
    );
};

export default GoogleLoginButton;
